import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';

  const REF_EAN_ERROR_TYPES = new Set<string>([
      'MISSING_REFERENCE',
      'MISSING_VLCODE',
      'MISSING_GENCODE',
      'INVALID_REFERENCE_FORMAT',
      'INVALID_VLCODE_FORMAT',
      'INVALID_PREFIX',
      'INVALID_LENGTH',
      'INVALID_CHECK_DIGIT',
      'REFERENCE_MISMATCH',
      'COLLISION_SUFFIX',
      'DUPLICATE_REFERENCE',
      'DUPLICATE_VLCODE',
      'DUPLICATE_GENCODE',
  ]);

@Injectable()
export class RefEanValidationInterceptor implements HttpInterceptor {
      constructor(private messageService: MessageService) {}

      intercept(
          request: HttpRequest<unknown>,
          next: HttpHandler
      ): Observable<HttpEvent<unknown>> {
          return next.handle(request).pipe(
              catchError((err: HttpErrorResponse) => {
                  if (this.isRefEanValidationError(err)) {
                      this.messageService.add({
                          key: 'global',
                          severity: 'error',
                          summary: 'Erreur de validation',
                          detail: err.error.message,
                          life: 5000,
                      });
                  }
                  return throwError(() => err);
              })
          );
      }

    private isRefEanValidationError(err: HttpErrorResponse): boolean {
              if (!err || (err.status !== 400 && err.status !== 409)) {
                  return false;
              }
              const body = err.error;
              return (
                  !!body &&
                  typeof body === 'object' &&
                  typeof body.errorType === 'string' &&
                  typeof body.message === 'string' &&
                  REF_EAN_ERROR_TYPES.has(body.errorType)
              );
          }
}
